import { DESCRIPTION_PRESETS } from '../constants'

const abbreviate = (description: string): string =>
  DESCRIPTION_PRESETS.find(preset => preset.description === description)?.abbreviation ??
  description

/**
 * The name a project is handed in under is not typed but composed, so it
 * follows the same shape for every project: `BV [EFH] Müller`. The bracketed
 * part is the description's short form, or the description itself when it was
 * written by hand.
 */
export const buildHandInProjectName = (description?: string, name?: string): string => {
  const projectKind = description?.trim()

  return ['BV', projectKind && `[${abbreviate(projectKind)}]`, name?.trim()]
    .filter(Boolean)
    .join(' ')
}
